import { render, staticRenderFns } from "./_product_li.vue?vue&type=template&id=531755dc&scoped=true&"
import script from "./_product_li.vue?vue&type=script&lang=js&"
export * from "./_product_li.vue?vue&type=script&lang=js&"
import style0 from "./_product_li.vue?vue&type=style&index=0&id=531755dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531755dc",
  null
  
)

export default component.exports